import { Injectable } from "@angular/core";
import { DataModel, MetaModel, WidgetModel } from "common/models/utility-models/base-model";
import { FormWidgetService } from "../form-widget.service";
import { BranchCategoryFormDataService } from "common/services/data-services/admin/branch-category/branch-category-form.service";
import { BranchCategoryModel } from "common/models/page-models/branch-category/branch-category-data.model";
import { BranchCategoryMetaModel } from "common/models/page-models/branch-category/branch-category-form-meta.model";



@Injectable({
    providedIn: 'root'
})
export class BranchCategoryFormWidgetService extends FormWidgetService<BranchCategoryModel> {
    constructor(protected ds: BranchCategoryFormDataService) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new BranchCategoryMetaModel();
        return meta.getMetaModel();
    }

    override prepareMetaModel(dataModel: DataModel, metaModel: BranchCategoryMetaModel, routeData: WidgetModel): Promise<BranchCategoryMetaModel> {
        return new Promise<BranchCategoryMetaModel>((resolve, reject) => {
            metaModel.pageTitle = dataModel.id !== 0 ?  'Update Branch Category' : 'Add Branch Category';
            resolve(metaModel);
        });
    }

}
